import { Component } from '@angular/core';
import { CustomerPage } from "../customer";
import { AlertController, ModalController, NavController, NavParams, PopoverController } from "ionic-angular";
import { RestrictionsPage } from "../restrictions/restrictions";
import { BalancePage } from "../balance/balance";
import { LocationPage } from "../location/location";

@Component({
  selector: 'page-customer-menu',
  templateUrl: 'customer-menu.html',
})
export class CustomerMenuPage {
  customer;
  foods;
  plans;
  old_foods;
  constructor(
    public modalCtrl: ModalController,
    private navParams: NavParams,
    private alertController: AlertController,
    private nav: NavController
  ) {

    this.customer = this.navParams.data.customer;
    this.foods = this.navParams.data.foods;
    this.old_foods = this.navParams.data.old_foods;
    this.plans = this.navParams.data.plans;
    console.log(this.customer);
  }

  newCustomer() {
    this.nav.push(CustomerPage, { customer: this.customer, old_foods: this.old_foods, foods: this.foods, plans: this.plans });
  }

  restrictions() {
    this.nav.push(RestrictionsPage, { user: this.customer });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CustomerMenuPage');
  }

  balance() {
    this.nav.push(BalancePage, { user: this.customer });
  }

  pin() {
    this.nav.push(LocationPage, { user: this.customer });
  }


  handleDelete() {
  }

  delete() {
    // alert to confirm
    // delete customer
    // delete customer from all plans
    this.alertController.create({
      title: 'Eliminar cliente',
      message: 'Estas seguro que deseas eliminar este cliente, esta acción no se puede deshacer.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Eliminar',
          handler: this.handleDelete
        }
      ]
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/customers/customer-menu/customer-menu.ts